import React from 'react';
import AppRoutes from './routes/AppRoutes';
import 'antd/dist/reset.css';

function App() {
  return <AppRoutes />;
}

export default App;
